import "core-js/modules/es.array.map";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { userFeedbackList, replyFeedback } from "@/api/gmtool/packageCode";
import questionDetails from "./components/questionDetails.vue";
import recover from "./components/recover.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "userFeedbackList",
  mixins: [gmTool],
  components: {
    questionDetails: questionDetails,
    recover: recover
  },
  data: function data() {
    return {
      paramsData: {
        page: 1,
        user_id: '',
        server_id: '',
        role_id: '',
        role_name: '',
        question: '',
        start_datetime: '',
        end_datetime: '',
        status: '2'
      },
      total: 0,
      date: null,
      feddStatus: [{
        label: this.$t('replied'),
        value: 1
      }, {
        label: this.$t('pendingReply'),
        value: 2
      }],
      recoverbData: {
        content: '',
        feedback_id: '',
        status: '',
        is_prod: ''
      },
      tabbleData: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    recoverChange: function recoverChange(item, index) {
      this.recoverbData.status = item.status;
      this.recoverbData.content = item.status == 1 ? item.reply.content : '';

      if (this.recoverbData.feedback_id == item.id) {
        item.isControls = !item.isControls;
        return;
      }

      this.recoverbData.feedback_id = item.id;
      this.recoverbData.is_prod = this.paramsData.is_prod;
      this.tabbleData.map(function (i) {
        i.isControls = item.id == i.id ? true : false;
      });
    },
    sendRecover: function sendRecover(index) {
      var _this2 = this;

      if (!this.recoverbData.content) {
        this.$message.error(this.$t('pleaseInputContent'));
        return;
      }

      replyFeedback(this.recoverbData).then(function (res) {
        if (res.status == 200) {
          _this2.$message.success(_this2.$t('replySuccess'));

          _this2.getList(_this2.paramsData.page);
        }
      });
    },
    getList: function getList(e) {
      var _this3 = this;

      this.tabbleData = [];
      this.paramsData.page = e;
      this.paramsData.start_datetime = this.date ? this.date[0] : '';
      this.paramsData.end_datetime = this.date ? this.date[1] : '';
      userFeedbackList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          res.data.data.map(function (i) {
            i.isControls = false;
          });
          _this3.tabbleData = res.data.data;
          _this3.total = res.data.total;
        }
      });
      return;
      var d = [{
        "id": 12,
        "user_id": "11",
        "server_id": "1",
        "role_id": "11",
        "role_name": "11",
        "question": "啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-14T09:39:36.000000Z",
        "updated_at": "2023-12-14T09:39:36.000000Z",
        "uid": "1",
        "answer": 0,
        isControls: true
      }, {
        "id": 11,
        "user_id": "11",
        "server_id": "1",
        "role_id": "11",
        "role_name": "11",
        "question": "1111111111",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:21:28.000000Z",
        "updated_at": "2023-12-13T07:21:28.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 10,
        "user_id": "10",
        "server_id": "1",
        "role_id": "10",
        "role_name": "10",
        "question": "1000000",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:21:19.000000Z",
        "updated_at": "2023-12-13T07:21:19.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 9,
        "user_id": "9",
        "server_id": "1",
        "role_id": "9",
        "role_name": "999",
        "question": "999999",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:21:07.000000Z",
        "updated_at": "2023-12-13T07:21:07.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 8,
        "user_id": "8",
        "server_id": "1",
        "role_id": "8",
        "role_name": "asda",
        "question": "8888",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:21:00.000000Z",
        "updated_at": "2023-12-13T07:21:00.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 7,
        "user_id": "7",
        "server_id": "1",
        "role_id": "7",
        "role_name": "75454",
        "question": "777777",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:20:52.000000Z",
        "updated_at": "2023-12-13T07:20:52.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 6,
        "user_id": "6",
        "server_id": "1",
        "role_id": "6",
        "role_name": "测试6",
        "question": "6666666",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:20:36.000000Z",
        "updated_at": "2023-12-13T07:20:36.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 5,
        "user_id": "5",
        "server_id": "1",
        "role_id": "5",
        "role_name": "测试5",
        "question": "555555",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:20:29.000000Z",
        "updated_at": "2023-12-13T07:20:29.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 4,
        "user_id": "4",
        "server_id": "1",
        "role_id": "4",
        "role_name": "测试4",
        "question": "4444444",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:20:23.000000Z",
        "updated_at": "2023-12-13T07:20:23.000000Z",
        "uid": "1",
        "answer": 0
      }, {
        "id": 3,
        "user_id": "3",
        "server_id": "1",
        "role_id": "3",
        "role_name": "测试2",
        "question": "2222222",
        "status": 2,
        "admin_id": 0,
        "created_at": "2023-12-13T07:20:16.000000Z",
        "updated_at": "2023-12-13T07:20:16.000000Z",
        "uid": "1",
        "answer": 0
      }];
      d.map(function (i) {
        i.isControls = false;
      });
      this.tabbleData = d;
    },
    handleClick: function handleClick(e) {
      this.getList(1);
    },
    unseal: function unseal(id) {
      var _this4 = this;

      this.$prompt(this.$t('pleaseInput'), this.$t('reply'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(function (_ref) {
        var value = _ref.value;
        banUser(_objectSpread(_objectSpread({}, d), _this4.paramsData)).then(function (res) {
          if (res.status == 200) {
            _this4.$message({
              message: _this4.$t('replySuccess'),
              type: 'success'
            });

            _this4.getList(_this4.paramsData.page);
          }
        });
      });
    }
  }
};